import React from 'react'

export default function LoadingScreen(props) {
    return (
        <div className={`loadingScreen ${props.className ? props.className : ""}`}>
            <div className="loadingScreen__spinner"></div>
        </div>
    )
}
